/* istanbul ignore next */
export var UNIQUE_CONFIG_KEY = 'frontend-favorites-assign-widget';
export var STORAGE_KEY_ON_BOARDING_DELETE_HIDE = 'hideFoldersOnBoardingDelete';
export var STORAGE_KEY_ON_BOARDING_ADD_HIDE = 'hideFoldersOnBoardingAdd';